import { DestroyRef, Directive, ElementRef, inject, OnInit, Renderer2 } from '@angular/core';

const TOAST_MESSAGE_SELECTOR = '.p-toast-message';
const HIDDEN_CLASS = 'toast-progress--hidden';

@Directive({
	selector: '[appToastProgressSync]',
})
export class ToastProgressSyncDirective implements OnInit {
	private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
	private readonly renderer = inject(Renderer2);
	private readonly destroyRef = inject(DestroyRef);

	ngOnInit(): void {
		const toastMessage = this.host.nativeElement.closest(TOAST_MESSAGE_SELECTOR);
		if (toastMessage === null) {
			return;
		}

		const stopMouseEnter = this.renderer.listen(toastMessage, 'mouseenter', () => this.hide());
		const stopMouseLeave = this.renderer.listen(toastMessage, 'mouseleave', () => this.showFromFull());

		this.destroyRef.onDestroy(() => {
			stopMouseEnter();
			stopMouseLeave();
		});
	}

	private hide(): void {
		this.renderer.addClass(this.host.nativeElement, HIDDEN_CLASS);
	}

	private showFromFull(): void {
		const bar = this.host.nativeElement;
		this.renderer.removeClass(bar, HIDDEN_CLASS);
		// Retrigger the keyframes from scaleX(1): drop the animation, force a reflow, restore it running.
		// animationName longhand leaves the inline animation-duration binding untouched.
		bar.style.animationName = 'none';
		void bar.offsetWidth;
		bar.style.animationName = '';
		bar.style.animationPlayState = 'running';
	}
}
